<template>
  <table  style="text-align: right;" class="col-lg-12">
    <template  v-for="(answ,index1) in ques.answers "   >
      <tr>
        <td  v-if="ques.showNumber">
            {{index1+1}}
        </td>
        <td  v-if="answ.url" style="width: 45px;">
            <img  v-bind:src="answ.url" style="width: 40px;"></img>
        </td> 
      </tr>
    </template>
  </table>
</template>

<script>
export default {
  name:"pages",
  props:{
    ques:{default:()=>{return {};}}
  }
}
</script>